import AppRecord from './AppRecord.js'

class EventLoadLog extends AppRecord {
}

export default EventLoadLog
